import React from "react";
import "../components/componentstyle/homeAbout.css";
import homeAboutImg from "../assets/homeAbout-img.jpg";

function HomeAbout() {
  return (
    <section className="mt-5 section">
      <div className="container homeabout-container">
        <div className="row homeabout-row">
          <div className="col-md-6 col-lg-6 homeAbout-left">
            {/* <div className="section-title">
              <h2>
                <span>About</span>Solid Export
              </h2>
            </div> */}
            <div className="abt-text">
              {/* <p id="para-txt">
                Cereals and pulses are one of the main elements in Indian foods.
                Indian food have been well-known over the world for their
                exceptional flavor, aroma, and excellent taste. We at Solid
                export believe that Indian culture and our extraordinary food
                variety should reach every side of the world.
              </p> */}
              <div className="exp-imp">
                <div className="exp-imp--heading pt-4">
                  <h2>MISSION</h2>
                  <div className="line"></div>
                </div>
                <p id="para-txt">
                  To connect Indian manufacturing excellence with global markets
                  by delivering high-quality products, reliable logistics, and
                  unmatched customer satisfaction.
                </p>
              </div>
              <div className="exp-imp">
                <div className="exp-imp--heading">
                  <h2>VISION</h2>
                  <div className="line"></div>
                </div>
                <p id="para-txt">
                To become a globally recognized export brand known for integrity, reliability, and innovation — empowering Indian products to reach every corner of the world.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 ">
            <div className="abt-img">
              <img src={homeAboutImg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeAbout;
